import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import styles from './CancelConfirmationForEmployer.module.css';
import HeroSectionForCancellation from '../../../components/Verification/HeroSectionForCancellation/HeroSectionForCancellation';
import { applyDiscount } from '../../../services/paymentService';
import { fetchUserByToken } from '../../../app/features/userSlice';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import {
    NotificationWhite,
    SupportIconWhite,
    WhiteGlobe,
    WhiteStar,
} from '../../../assets/images/icons';

function CancelConfirmationForEmployer({ cancelSubscription }) {
    const { t } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const [cancellationMessage, setCancellationMessage] = useState('');
    const [selectedReason, setSelectedReason] = useState('no_longer_needed');
    const [isModalVisible, setIsModalVisible] = useState(false);

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    const userToken = useSelector((state) => state.user.token);

    const feedbackOptions = [
        { value: 'no_longer_needed', label: t('feedback.options.no_longer_needed') },
        { value: 'better_alternative', label: t('feedback.options.better_alternative') },
        { value: 'lack_of_matches', label: t('feedback.options.lack_of_matches') },
        { value: 'budget_constraints', label: t('feedback.options.budget_constraints') },
        { value: 'other', label: t('feedback.options.other') },
    ];

    const handleApplyDiscountSubscription = (perOff) => {
        if (perOff == "50%") {
            setIsModalVisible(true)
            applyDiscount(user.subscriptionDetail.id, perOff, user.id)
                .then(() => {
                    // dispatch(fetchUserByToken(userToken));
                })
                .catch(console.error);
        } else {
            applyDiscount(user.subscriptionDetail.id, perOff, user.id)
                .then(() => {
                    dispatch(fetchUserByToken(userToken));
                })
                .catch(console.error);
        }
    };

    const handleSubmit = (value, isClaim) => {
        if (isClaim) handleApplyDiscountSubscription('100%');
        else if (value === 'keep') handleApplyDiscountSubscription('50%');
        else setShowFeedback(true);
    };

    const handleFeedbackChange = (value) => { setSelectedReason(value); };

    const handleProceedToCancel = () => { setShowPopup(true); };

    const handleConfirmCancellation = () => {
        setShowPopup(false);
        setCancellationMessage(
            t('msgBeforeDate') + dateConverter(user?.subscriptionDetail?.current_period_end) + '. ' + t('msgAfterDate')
        );
        cancelSubscription()
    };

    const handleCancelPopup = () => { setShowPopup(false); };
    // console.log(user?.subscriptionDetail?.current_period_end, "user?.subscriptionDetail?.current_period_end")
    const dateConverter = (value) => {
        const timestamp = value;
        const date = new Date(timestamp * 1000);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        return formattedDate
    }
    // user?.subscriptionDetail?.current_period_end
    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>FindCV - {t('CancelConfirmation.title')}</title>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.HeroSectionWrapper}>
                    {showFeedback ? (
                        <HeroSectionForCancellation
                            claim
                            title={
                                <>
                                    {t('herosectionforcancellationClaim.title1')}{' '}
                                    <span style={{ color: '#9BBB23', fontSize: '30px' }}>
                                        {t('herosectionforcancellationClaim.title2')}
                                    </span>{' '}
                                    {t('herosectionforcancellationClaim.title3')}
                                </>
                            }
                            onSubmit={handleSubmit}
                            desc={t('herosectionforcancellationClaim.desc')}
                        />
                    ) : (
                        <HeroSectionForCancellation
                            title={
                                <>
                                    {t('herosectionforcancellation.title1')}{' '}
                                    <span style={{ color: '#9BBB23', fontSize: '30px' }}>
                                        {t('herosectionforcancellation.title2')}
                                    </span>{' '}
                                    {t('herosectionforcancellation.title3')}
                                </>
                            }
                            onSubmit={handleSubmit}
                            desc={t('herosectionforcancellation.desc')}
                        />
                    )}
                </div>
                <div className={styles.confirmationWrapper} style={{ padding: '0px 20px' }}>
                    <p className={styles.heading}>
                        {t('CancelConfirmationSubscription.heading')}
                    </p>
                    <div className={styles.cardWrapper}>
                        {[
                            {
                                title: t('CancelConfirmationSubscription.cards1.title'),
                                desc: t('CancelConfirmationSubscription.cards1.desc'),
                                icon: WhiteStar,
                            },
                            {
                                title: t('CancelConfirmationSubscription.cards2.title'),
                                desc: t('CancelConfirmationSubscription.cards2.desc'),
                                icon: NotificationWhite,
                            },
                            {
                                title: t('CancelConfirmationSubscription.cards3.title'),
                                desc: t('CancelConfirmationSubscription.cards3.desc'),
                                icon: SupportIconWhite,
                            },
                            {
                                title: t('CancelConfirmationSubscription.cards4.title'),
                                desc: t('CancelConfirmationSubscription.cards4.desc'),
                                icon: WhiteGlobe,
                            },
                        ].map((item, index) => (
                            <div className={styles.card} key={index.toString()}>
                                <div className={styles.iconContainer}>
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <p className={styles.title}>{item.title}</p>
                                <p className={styles.desc}>{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    {showFeedback && (
                        <div className={`${styles.feedbackSection} feedBackScroll`}>
                            <h2 className={styles.feedbackHeading}>{t('feedback.heading')}</h2>
                            <p className={styles.feedbackSubheading}>
                                {t('feedback.subheading')}
                            </p>
                            <div className={styles.radioGroup}>
                                {feedbackOptions.map((option) => (
                                    <div key={option.value} className={styles.radioOption}>
                                        <label>
                                            <input
                                                type="radio"
                                                name="feedback"
                                                value={option.value}
                                                checked={selectedReason === option.value}
                                                onChange={() => handleFeedbackChange(option.value)}
                                            />
                                            {option.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <button
                                className={styles.proceedButton}
                                onClick={handleProceedToCancel}
                            >
                                {t('feedback.proceedButton')}
                            </button>
                        </div>
                    )}

                    {/* Popup */}
                    {showPopup && (
                        <div className={styles.popup}>
                            <div className={styles.popupContent}>
                                <p>{t('cancellConfirmationMsg')}</p>
                                <button
                                    className={styles.confirmButton}
                                    onClick={handleConfirmCancellation}
                                >
                                    {t('jobPreferences.relocationSection.options.yes')}
                                </button>
                                <button
                                    className={styles.cancelButton}
                                    onClick={handleCancelPopup}
                                >
                                    {t('No')}
                                </button>
                            </div>
                        </div>
                    )}
                    {cancellationMessage && (
                        <div className={styles.popup}>
                            <div className={styles.popupContent}>
                                {/* Your subscription cancellation request has processed, subscription will be cancelled at the end of your billing cycle on 
                            23 Oct, 2025. 
                            You can cancel the subscription cancellation request any time from Manage Billing page */}
                                <p>{cancellationMessage}</p>
                                <button
                                    className={styles.modalCloseButton}
                                    onClick={() => {
                                        dispatch(fetchUserByToken(userToken));
                                        setIsModalVisible(false)
                                    }}
                                >
                                    {t(`general.UI.goToBilling`)}
                                </button>
                            </div>
                        </div>
                    )}

                    {isModalVisible && (
                        <div className={styles.modalOverlay}>
                            <div className={styles.modalContent}>
                                <p>
                                    {t('appliedDiscountMessage')}
                                </p>
                                <button
                                    className={styles.modalCloseButton}
                                    onClick={() => {
                                        dispatch(fetchUserByToken(userToken));
                                        setIsModalVisible(false)
                                    }}
                                >
                                    {t(`general.UI.goToBilling`)}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CancelConfirmationForEmployer;
